var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"light"}},[_c('div',{staticClass:"ellipsis-text-content"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"ellipsis-text-tooltip",style:({'max-width': _vm.tooltipWidth}),attrs:{"slot":"content"},slot:"content"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }